<template>
    <div class="order_list">
      <!--订单列表头部-->
      <div class="order_list_top">
        <div class="order_list_upper">
          <div class="first">
            <div><input v-model.trim="orderNum" maxlength="50" type="text" placeholder="平台订单号/内部订单号"/></div>
            <div class="w_percent8"><input v-model.trim="consignee" maxlength="50" type="text" placeholder="收货人"/></div>
            <div class=""><input v-model.trim="tel" maxlength="30" type="text" placeholder="联系电话"/></div>
            <!--<div class=""><input v-model.trim="remark" type="text" placeholder="备注"/></div>-->
            <div class=""><input v-model.trim="courierNum" maxlength="50" type="text" placeholder="快递单号"/></div>
            <div class="w_percent8"><input v-model.trim="goodsNum" maxlength="50" type="text" placeholder="货号"/></div>
            <div class="w_percent8"><input v-model.trim="color" maxlength="50" type="text" placeholder="颜色"/></div>
            <div class="w_percent8"><input v-model.trim="size" maxlength="50" type="text" placeholder="尺码"/></div>
            <div class="w_percent8">
              <el-select v-model="selectFlag" :value="selectFlag" placeholder="旗帜">
                <el-option
                  v-for="item in flagList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent8">
              <el-select v-model="selectSource" :value="selectSource" placeholder="来源">
                <el-option
                  v-for="item in sourceList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent8">
              <el-select v-model="selectLoseMoney" :value="selectLoseMoney" placeholder="亏本">
                <el-option
                  v-for="item in loseMoneyList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="second">
            <div class="w_percent10">
              <el-select v-model="selectStore" :value="selectStore"
                multiple
                collapse-tags
                placeholder="店铺">
                <el-option v-for="item in storeList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10">
              <el-select v-model="selectOrderTime" :value="selectOrderTime" placeholder="下单时间">
                <el-option
                  v-for="item in orderTimeList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent11">
              <el-date-picker
                v-model.trim="startTime"
                type="datetime"
                placeholder="年/月/日"
                format="yyyy/MM/dd HH:mm:ss">
              </el-date-picker>
            </div>
            <div class="lh33">~</div>
            <div class="w_percent11">
              <el-date-picker
                v-model.trim="endTime"
                type="datetime"
                placeholder="年/月/日"
                format="yyyy/MM/dd HH:mm:ss">
              </el-date-picker>
            </div>
            <div class="w_percent8">
              <el-select v-model="selectOrderStatus" :value="selectOrderStatus"
                         multiple
                         collapse-tags
                         placeholder="状态">
                <el-option v-for="item in orderStatusList"
                           :key="item.id"
                           :label="item.text"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10">
              <el-select v-model="selectChannelValue" :value="selectChannelValue"
                multiple
                collapse-tags
                placeholder="渠道">
                <el-option v-for="item in channelList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent8">
              <el-select v-model="selectCourierCompany" :value="selectCourierCompany" multiple
                         collapse-tags
                         placeholder="快递公司">
                <el-option v-for="item in courierCompanyList"
                           :key="item.id"
                           :label="item.text"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div><a class="fcLinkA lh33 ml0 mr10" @click="showAdvancedSearch()">显示高级搜索</a></div>
            <button class="btn btn_normal" @click="queryData()">查询</button>
            <div><a class="fcLinkA lh33 ml10" @click="resetData()">查询复位</a></div>
          </div>
        </div>
        <div class="order_list_under" v-if="advancedSearch">
          <div class="third">
            <div class="w_percent10">
              <el-select v-model="selectRegion" :value="selectRegion" placeholder="地区">
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10">
              <el-select v-model="selectProvince" :value="selectProvince" @change="getAllCityList" placeholder="省份">
                <el-option
                  v-for="item in provincesList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10">
              <el-select v-model="selectCity" :value="selectCity" @change="getAllAreaList" placeholder="城市">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10">
              <el-select v-model="selectArea" :value="selectArea" placeholder="城区">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10"><input v-model.trim="buyerID" maxlength="50" type="text" placeholder="买家ID"/></div>
            <div class="w_percent8">
              <el-select v-model="selectIsSalesAfter" :value="selectIsSalesAfter" placeholder="请选择">
                <el-option
                  v-for="item in isSalesAfter"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w70 lh33">货品数量:</div>
            <div class="w_percent4"><input title="开始数量" v-model.number="startNum" maxlength="10" type="text"/></div>
            <div class="lh33">~</div>
            <div class="w_percent4"><input title="结束数量" v-model.number="endNum" maxlength="10" type="text"/></div>
            <div class="w_percent8">
              <el-select v-model="selectRemarkType" :value="selectRemarkType" placeholder="备注">
                <el-option
                  v-for="item in remarkTypeList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="w_percent10"><input v-model.trim="remarkTypeVal" title="备注类型的内容" maxlength="100" type="text"/></div>
            <div class="w_percent8">
              <el-select v-model="selectOrderType" :value="selectOrderType" placeholder="订单类型">
                <el-option
                  v-for="item in orderTypeList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="fourth">
            <div><input v-model="hideCancelOrder" type="checkbox" id="hide_cancel_order"><label for="hide_cancel_order">隐藏交易取消的订单</label></div>
            <div><input v-model="hideSalesAfterOrder" type="checkbox" id="hide_sales_after_order"><label for="hide_sales_after_order">隐藏产生售后的订单</label></div>
            <div><input v-model="hideReplacementOrder" type="checkbox" id="hide_replacement_order"><label for="hide_replacement_order">隐藏置换的订单</label></div>
            <div><input v-model="hideFilterOrder" type="checkbox" id="hide_filter_order"><label for="hide_filter_order">隐藏过滤的订单</label></div>
            <div><input v-model="showPrepaidOrder" type="checkbox" id="show_prepaid_order"><label for="show_prepaid_order">显示预付的订单</label></div>
            <!--<div><input v-model="showAllOrder" type="checkbox" id="show_all_order"><label for="show_all_order">展示全部订单</label></div>-->
            <div><input v-model="showFailOrder" type="checkbox" id="show_fail_order"><label for="show_fail_order">显示同步发货失败订单</label></div>
            <div><input v-model="hideDuOrders" type="checkbox" id="hide_du_orders"><label for="hide_du_orders">隐藏得物订单</label></div>
          </div>
        </div>
      </div>
      <!--订单处理按钮-->
      <div class="order_btn">
        <button @click="orderCtrlBtn('mergerOrder')" class="btn btn_normal">合并订单</button>
        <button @click="orderCtrlBtn('batchAudit')" class="btn btn_normal">批量审单</button>
        <button @click="orderCtrlBtn('batchPayment')" class="btn btn_normal">批量付款</button>
        <button @click="orderCtrlBtn('allPayment')" class="btn btn_normal">全部付款</button>
        <button @click="orderCtrlBtn('activationOrder')" class="btn btn_normal">激活订单</button>
        <button @click="orderCtrlBtn('cancelOrder')" class="btn btn_normal">取消订单</button>
        <button @click="orderCtrlBtn('channelOrder')" class="btn btn_normal">渠道重配</button>
        <!--<button @click="orderCtrlBtn('exportOrder')" class="btn btn_normal">导出订单</button>-->
        <!--<button @click="orderCtrlBtn('addOrder')" class="btn btn_normal">添加货品</button>-->
        <button @click="orderCtrlBtn('sellerRemarks')" class="btn btn_normal">卖家备注</button>
        <button @click="orderCtrlBtn('internalRemarks')" class="btn btn_normal">内部备注</button>
        <button @click="orderCtrlBtn('syncOnlineOrderSend')" class="btn btn_normal">同步发货信息</button>
        <button @click="ctrlBtn('accountsExport', null)" class="btn btn_normal">对账导出</button>
        <button @click="ctrlBtn('detailExport', null)" class="btn btn_normal">导出明细</button>
        <button @click="orderCtrlBtn('batchPullBack', null)" class="btn btn_normal">批量撤回</button>
        <!--<button @click="ctrlBtn('aCheckList', null)" class="btn btn_normal">一键审单</button>-->
      </div>
      <!--订单信息列表-->
      <div class="order_list_msg" :class="{'hminus180' : advancedSearch,  'hminus120' : !advancedSearch}">
        <!--表格-->
        <table class="table tb_border">
          <thead>
          <tr>
            <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
            <th>订单号</th>
            <th>状态</th>
            <!--<th>售后状态</th>-->
            <th>店铺</th>
            <th>来源</th>
            <th>收货人</th>
            <th>明细</th>
            <th>渠道</th>
            <th>货款(元)</th>
            <!--<th class="no_newline">运费</th>-->
            <th>物流</th>
            <th>时间</th>
            <th class="w140">备注</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index" :class="{'bgy' : item.SysStatusName === '部分发货', 'bgc' : item.SysStatusName === '整单缺货'}">
          <tr>
            <td rowspan="3"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
            <td class="text_left no_newline">
              <p>内部:
                <a class="fcLinkA" title="内部订单号" @click="ctrlBtn('orderDetail', item)">{{item.OrderId}}</a>
                <i v-if="item.SplitJoinType === 2 || item.SplitJoinType === 4" @click="ctrlBtn('splitOrderDetail', item)" class="iconfont icon-eyes fr"></i>
                <!--<i @click="ctrlBtn('splitOrderDetail', item)" class="iconfont icon-eyes fr"></i>-->
              </p>
              <!--<p>平台:{{item.OutOrderId}}</p>-->
              <p v-html="'平台:' + (item.OutOrderId).replace(/,/g, '</br>')">{{item.OutOrderId}}</p>
            </td>
            <td class="no_newline">
              {{item.SysStatusName}}
              <p>
                <a class="fcLinkA" v-if="!item.RefundList || !item.RefundList.length" title="申请售后" @click="toAfterSalesApply(item)">申请售后</a>
              </p>
              <p v-if="item.RefundList.length">
                <a class="fcLinkA" title="存在售后" @click="toAfterSalesList(item)">存在售后</a>
              </p>
              <p v-if="item.SyncFlag === 3">
              <!--<p>-->
                <a title="同步失败状态" @click="ctrlBtn('synchronizationFailureFlag', item)">同步发货失败</a>
              </p>
            </td>
           <!-- <td class="no_newline">
              <a v-if="!item.RefundList || !item.RefundList.length" title="申请售后" @click="toAfterSalesApply(item)">申请售后</a>
              <p v-if="item.RefundList.length" v-for="(salesAFItem, i) in item.RefundList" :key="i">
                <a title="售后列表" @click="toAfterSalesList(salesAFItem)">{{salesAFItem.RefundId}}</a>
              </p>
            </td> -->
            <td class="no_newline">{{item.ShopName}}</td>
            <td>{{item.OrderSourceName}}</td>
            <td class="no_newline fcBlue"><a title="收货信息" @click="ctrlBtn('modifyReceivingInformation', item)">{{item.ReceiveName}}</a></td>
            <td class="detail">
              <div>
                <table class="table">
                  <tbody>
                  <tr class="pl5 pr5 no_newline" v-for="(itemGoods, indexGoods) in item.AgentDetailList" :key="indexGoods" @click="getOrderDetailInventory('orderDetailInventory', item.OrderId, itemGoods)">
                    <td style="padding-right: 0">{{itemGoods.GoodsId}},</td>
                    <td>{{itemGoods.Size}},</td>
                    <td>{{itemGoods.Quantity}}</td>
                    <td v-if="item.SysStatusName === '部分发货'" class="fcDel">[{{itemGoods.SendQuantity}}]</td>
                  </tr>
                  </tbody>
                </table>
                <!--{{itemGoods.GoodsId}},{{itemGoods.Size}},{{itemGoods.Quantity}}-->
                <!--<i v-if="itemGoods.quantityOutOfStock !== 0" class="fcDel">{{itemGoods.quantityOutOfStock}}</i>-->
              </div>
            </td>
            <td v-if="item.StoreroomName">
              <!--<a class="ml10 no_newline" title="改仓" @click="ctrlBtn('changeWarehouse', item)">{{item.SupplierCode}}_{{item.StoreroomName}}</a>-->
              <a class="ml10 no_newline" title="改仓" @click="ctrlBtn('changeWarehouse', item)">{{item.StoreroomName}}</a>
              <div v-if="item.StoreroomQQ">
                <a :href="'tencent://message/?uin=' + item.StoreroomQQ + '&Menu=yes& Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45'">
                  <img src="../../../assets/img/qq.gif" height="17" width="25" title="客服"/>
                </a>

                <!--<a title="客服">{{item.StoreroomQQ}}</a>-->
              </div>
            </td>
            <td v-if="!item.StoreroomName">
              <a v-if="item.SysStatusName === '待审'" class="ml10 no_newline" title="改仓" @click="ctrlBtn('changeWarehouse', item)">[空]</a>
              <p v-if="item.SysStatusName !== '待审'">[空]</p>
            </td>
            <td class="no_newline text_left">
              <p v-if="item.OrderSourceName !== '零售下单'">店铺:{{item.PaymentAmount}}</p>
              <!--<p>买付:{{item.TotalAmount}}</p>-->
              <p>交单:{{item.OrderCost}}</p>
              <p>实发:{{item.SendOrderCost}}</p>
              <p v-if="item.SendCourierFee">运费:{{item.SendCourierFee}}</p>
              <p v-if="!item.SendCourierFee && item.CourierFee">运费:{{item.CourierFee}}</p>
              <p v-if="!item.SendCourierFee && !item.CourierFee">运费:0</p>
            </td>
           <!-- <td class="no_newline text_left">
              <p class="pl5">{{item.PostAmount}}</p>
              <p class="pl5">{{item.CourierFee}}</p>
              <p class="pl5">{{item.SendCourierFee}}</p>
            </td> -->
            <td v-if="item.SysStatusName === '部分发货' || item.SysStatusName === '已发货' || item.SysStatusName === '交易完成'" class="no_newline">
              <p>{{item.SendLogisticName}}</p>
              <a v-if="item.ExpressNum" @click="ctrlBtn('modifyLogistic', item)">{{item.ExpressNum}}</a>
            </td>
            <td v-if="item.SysStatusName !== '部分发货' && item.SysStatusName !== '已发货' && item.SysStatusName !== '交易完成'" class="no_newline">
              <p v-if="item.SysStatusName !== '待审'">{{item.LogisticName}}</p>
              <a v-if="item.SysStatusName === '待审'" class="fcLinkA" @click="ctrlBtn('modifyLogisticPending', item)">{{item.LogisticName}}</a>
              <a v-if="item.ExpressNum">{{item.ExpressNum}}</a>
              <!--<a v-if="item.ExpressNum" @click="ctrlBtn('modifyLogistic', item)">{{item.ExpressNum}}</a>-->
            </td>
            <td class="no_newline text_left">
              <!--<p>买付:{{item.PayTime | time}}</p>-->
              <p>下单:{{item.OrderCreateTime | timedate}}</p>
              <p>交单:{{item.DeliveryTime | timedate}}</p>
              <p>实发:{{item.SupplySendTime | timedate}}</p>
            </td>
            <td class="no_newline text_left remark">
              <p>
                <label class="fl">系统:</label><span class="fcBlue fwb" :title="item.SysMemo">{{item.SysMemo}}</span>
              </p>
              <p v-if="item.OrderSourceName !== '零售下单'" class="pr">
                <label class="fl">买家:</label><span :title="item.BuyerMessage">{{item.BuyerMessage}}</span>
                <img class="pa r0" v-if="item.Flag === 1" src="../../../assets/img/flag_red.png" height="12" width="12"/>
                <img class="pa r0" v-if="item.Flag === 2" src="../../../assets/img/flag_yellow.png" height="12" width="12"/>
                <img class="pa r0" v-if="item.Flag === 3" src="../../../assets/img/flag_green.png" height="12" width="12"/>
                <img class="pa r0" v-if="item.Flag === 4" src="../../../assets/img/flag_blue.png" height="12" width="12"/>
                <img class="pa r0" v-if="item.Flag === 5" src="../../../assets/img/flag_purple.png" height="12" width="12"/>
              </p>
              <div class="pr">
                <p class="no_newline h16"><label class="fl">卖家:</label><span :title="item.SellerMemo">{{item.SellerMemo}}</span></p>
                <p class="no_newline h16"><label class="fl">内部:</label><span class="fcDel" :title="item.AgentRemark">{{item.AgentRemark}}</span></p>
                <i class="iconfont icon-modify pa" @click="ctrlBtn('remarks', item)"></i>
              </div>
            </td>
            <td class="ctrl_btns">
              <a v-if="item.SysStatusName === '待付款'" class="no_newline mr5" @click="ctrlBtn('batchPayment', item)">付款</a> <!--@click="orderCtrlBtn('batchPayment')"-->
              <a v-if="item.SysStatusName === '待审'" class="no_newline mr5" @click="ctrlBtn('batchAudit', item)">审单</a>
              <!--<a v-if="item.SysStatusName === '待审' || item.SysStatusName === '待付款' || item.SysStatusName === '已付款'" class="no_newline mr5" @click="ctrlBtn('cancelOrder', item)">取消</a>-->
              <a v-if="item.SysStatusName === '待审' || item.SysStatusName === '待付款'" class="no_newline mr5" @click="ctrlBtn('cancelOrder', item)">取消</a>
              <a v-if="item.SysStatusName === '已付款'" class="no_newline mr5" @click="ctrlBtn('cancelOrder', item)">撤回取消</a>
              <a v-if="item.SysStatusName === '待审'" class="no_newline mr5" @click="ctrlBtn('changeGoods', item)">改货</a>
              <a v-if="item.SysStatusName === '待审'" class="no_newline mr5" @click="ctrlBtn('splitOrder', item)">拆单</a>
              <a v-if="item.SysStatusName === '待审'" class="no_newline mr5" @click="ctrlBtn('channelOrder', item)">渠道重配</a>
              <!--<a v-if="item.SysStatus === 1 || item.SysStatus === 3 || item.SysStatus === 4" @click="ctrlBtn('intelligentSplitOrder', item)">智能拆单</a>-->
              <a v-if="item.SysStatusName === '交易取消'" @click="ctrlBtn('activationOrder', item)">激活</a>
              <a v-if="item.SysStatusName === '待付款' || item.SysStatusName === '已付款' || item.SysStatusName === '整单缺货'" class="no_newline" @click="ctrlBtn('pullBack', item)">撤回</a>
<!--              <a v-if="item.SysStatusName === '待审'" @click="copyOrderSingle(item)">复制</a>-->
              <a v-if="item.SysStatusName === '待审'" @click="ctrlBtn('copyOrder', item)">复制</a>
              <a @click="ctrlBtn('checkLog', item)">日志</a>
            </td>
          </tr>
          </tbody>
          <tbody v-if="!list.length">
          <tr>
            <td colspan="13">暂时没有相关信息</td>
          </tr>
          </tbody>
        </table>

        <!--分页-->
        <div class="text_right mt20">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 100, 500]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--弹出框-->
      <order-list-embed-msg v-if="isShow"
                            :title="dialogTitle"
                            :showType="dialogShowType"
                            :orderMsg="orderMsg"
                            :isBatch="isBatch"
                            @cancelbtn="getSelectDialogEmbed"></order-list-embed-msg>

      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
    </div>
</template>

<script>
  import OrderListEmbedMsg from './order-list-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'order-list',
    components: {OrderListEmbedMsg, MsgDialog, LoadingDialog},
    computed: {
      rightTabsContent: {
        // getter
        get: function () {
          return this.$store.state.tabs;
        },
        // setter
        set: function (newVal) {
          this.$store.state.tabs = newVal;
          return this.$store.state.tabs;
        }
      },
      rightTabsPosition: {
        get: function () {
          return this.$store.state.tabsPosition;
        },
        set: function (newVal) {
          this.$store.state.tabsPosition = newVal;
          return this.$store.state.tabsPosition;
        }
      }
    },
    watch: { // 深度watch
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        list: [], // 列表信息
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        orderMsg: null, // 订单信息
        orderNum: null, // 平台订单号/内部订单号
        consignee: null, // 收货人
        tel: null, // 联系电话
        // remark: null, // 备注
        courierNum: null, // 快递单号
        goodsNum: null, // 货号
        color: null, // 颜色
        size: null, // 尺码
        flagList: [ // 旗帜下拉框列表
          {id: null, text: '旗帜'},
          {id: 1, text: '红'},
          {id: 2, text: '黄'},
          {id: 3, text: '绿'},
          {id: 4, text: '蓝'},
          {id: 5, text: '紫'}
          // {id: 0, text: '灰'}
        ],
        selectFlag: null, // 旗帜选择
        sourceList: [], // 来源下拉框列表
        selectSource: '', // 来源选择
        loseMoneyList: [ // 亏本下拉框列表
          {id: null, text: '亏本'},
          {id: true, text: '是'},
          {id: false, text: '否'}
        ],
        selectLoseMoney: null, // 亏本选择
        storeList: [], // 店铺下拉
        selectStore: [], // 店铺选择
        orderTimeList: [
          {id: 0, text: '时间类型'},
          {id: 1, text: '下单时间'},
          {id: 2, text: '付款时间'},
          {id: 3, text: '发货时间'},
          {id: 4, text: '交单时间'}
        ], // 下单时间
        selectOrderTime: 1, // 选择下单时间类型
        startTime: this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 * 15)), // 开始时间
        endTime: this.Global.timeFormatEnd(new Date()), // 结束时间
        orderStatusList: [], // 订单状态
        selectOrderStatus: [], // 选择的状态
        channelList: [], // 渠道下拉列表
        selectChannelValue: [], // 选择的渠道列表
        courierCompanyList: [], // 快递公司下拉
        selectCourierCompany: [], // 选择的快递公司
        regionList: [], // 地区下拉
        selectRegion: null, // 选择的地区
        provincesList: [], // 省份下拉
        selectProvince: null, // 选择的省份
        cityList: [], // 城市下拉
        selectCity: null, // 选择的城市
        areaList: [], // 区下拉
        selectArea: null, // 选择的区
        buyerID: null, // 买家ID
        isSalesAfter: [ // 是否售后下拉
          {id: null, text: '是否售后'},
          {id: 1, text: '是'},
          {id: 2, text: '否'}
        ],
        selectIsSalesAfter: null, // 选择的是否售后
        startNum: null, // 开始数量
        endNum: null, // 结束数量
        remarkTypeList: [], // 备注下拉
        selectRemarkType: null, // 选择的备注下拉
        remarkTypeVal: null, // 备注类型的内容
        orderTypeList: [
          {id: null, text: '订单类型'},
          {id: 1, text: '普通订单'},
          {id: 2, text: '货到付款'}
        ], // 订单类型下拉
        selectOrderType: null, // 选择的订单类型
        hideCancelOrder: false, // 隐藏交易取消的订单
        hideSalesAfterOrder: false, // 隐藏产生售后的订单
        hideReplacementOrder: false, // 隐藏置换的订单
        hideFilterOrder: false, // 隐藏过滤的订单
        showPrepaidOrder: false, // 显示预付的订单
        showAllOrder: false, // 展示全部订单
        showFailOrder: false, // 显示同步发货失败订单
        hideDuOrders: true, // 隐藏得物订单
        advancedSearch: false, // 高级搜索显示
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isBatch: false, // 是否批量
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 20, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取当前时间 + 15天前时间
      getTime() {
        const nowDate = new Date();
        this.startTime = this.Global.timeFormatStart(new Date(nowDate - 1000 * 60 * 60 * 24 * 15));
        this.endTime = this.Global.timeFormatEnd(new Date());
      },

      // 获取平台来源下拉框信息
      getOrderSourceList() {
        this.$axios.get(this.Global.getOrderSourceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sourceList = res.data.resData;
            this.sourceList.splice(0, 0, {id: '', text: '来源'});
            this.selectSource = '';
          } else {
            this.sourceList = [];
            this.selectSource = res.data.errorMsg;
          }
        });
      },

      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              // this.selectStore = res.data.resData[0].id;
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
            }
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 加载订单状态下拉数据
      getOrderSysStatusList() {
        this.$axios.get(this.Global.getOrderSysStatusList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.orderStatusList = res.data.resData;
          }
        });
      },

      // 加载订单备注类型下拉数据
      getOrderRemarkTypeList() {
        this.$axios.get(this.Global.getOrderRemarkTypeList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.remarkTypeList = res.data.resData;
            this.remarkTypeList.splice(0, 0, {id: '', text: '备注'});
            this.selectRemarkType = ''
          } else {
            this.remarkTypeList = [];
            this.selectRemarkType = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
          }
        });
      },

      // 获取地区下拉框
      getAllRegionList() {
        this.$axios.get(this.Global.getAllRegionList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.regionList = res.data.resData;
          }
        });
      },

      // 获取省份下拉框
      getAllProvinceList() {
        this.$axios.get(this.Global.getAllProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.provincesList = res.data.resData;
            this.provincesList.splice(0, 0, {id: null, text: '省份'});
            this.selectProvince = null;
          } else {
            this.provincesList = [];
            this.selectProvince = res.data.errorMsg;
          }
        });
      },

      // 获取城市下拉框
      getAllCityList() {
        this.selectCity = null;
        this.selectArea = null;
        if (this.selectProvince) {
          this.$axios.get(this.Global.getAllCityList(this.selectProvince)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cityList = res.data.resData;
            } else {
              this.selectCity = res.data.errorMsg;
            }
          });
        }
      },

      // 获取区下拉框
      getAllAreaList() {
        this.selectArea = null;
        if (this.selectCity) {
          this.$axios.get(this.Global.getAllAreaList(this.selectCity)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.areaList = res.data.resData;
            } else {
              this.selectArea = res.data.errorMsg;
            }
          });
        }
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            // this.selectChannelValue = '';
          } else {
            this.channelList = [];
            // this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 检查格式
      checkFormat() {
        if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择结束时间';
          return;
        } else if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择开始时间';
          return;
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
          return;
        } else if (this.startNum && !this.endNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入货品结束数量';
          return;
        } else if (!this.startNum && this.endNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入货品开始数量';
          return;
        } else if (this.startNum > this.endNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '货品开始数量不能大于结束数量';
          return;
        }
        return true;
      },

      // 根据条件查询
      queryData() {
        if (this.checkFormat()) {
          this.currentPage = 1;
          this.isLoading = true;
          this.getAgentOrderListPageData();
        }
      },

      // 分销端 订单列表分页数据 --- 新的
      getAgentOrderListPageData() {
        this.isLoading = true;
        const params = {
          OrderIdOrOutOrderId: this.orderNum, // 平台订单号/内部订单号
          ReceiveName: this.consignee, // 收货人
          Phone: this.tel, // 联系电话
          ExpressNum: this.courierNum, // 快递单号
          GoodsId: this.goodsNum, // 货号
          ColorName: this.color, // 颜色
          SizeName: this.size, // 尺码
          Flag: this.selectFlag, // 旗帜 灰0(不要此值) 红1 黄2 绿3 蓝4 紫5
          Source: this.selectSource, // 来源 1淘宝 2天猫 3京东 4拼多多 5唯品会 6零售下单
          LoseMoney: this.selectLoseMoney, // 是否亏本
          ShopList: this.selectStore, //  店铺
          QueryTimeType: this.selectOrderTime, // 查询时间类型 1下单时间 2付款时间 3发货时间 4交单时间
          QueryBeginTime: this.Global.timeFormatEight(this.startTime), // 查询开始时间
          QueryEndTime: this.Global.timeFormatEight(this.endTime), // 查询结束时间
          SysStatus: this.selectOrderStatus, // 状态 1待审、2待付款、3已付款、4待发货、5已发货、6部分发货、7整单缺货、8交易完成、9交易取消 ,
          StoreroomList: this.selectChannelValue, // 渠道
          LogisticList: this.selectCourierCompany, // 快递公司
          RegionId: this.selectRegion, // 地区
          ProvinceId: this.selectProvince, // 省份
          CityId: this.selectCity, // 城市
          AreaId: this.selectArea, // 区
          BuyerNick: this.buyerID, // 买家id
          ReStatus: this.selectIsSalesAfter, // 是否售后 1=无售后  2=有售后
          BeginQuantity: this.startNum, // 货品数量 起始
          EndQuantity: this.endNum, // 货品数量 结束
          RemarkType: this.selectRemarkType, // 备注类型 1 内部备注 2 系统备注 3 卖家备注 4 买家备注
          RemarkContent: this.remarkTypeVal, // 备注内容
          OrderType: this.selectOrderType, // 订单类型 1 普通订单 2 货到付款
          HideCancelOrder: this.hideCancelOrder, // 隐藏交易取消的订单
          HideReOrder: this.hideSalesAfterOrder, // 隐藏产生售后的订单
          HideExchangeOrder: this.hideReplacementOrder, // 隐藏置换的订单
          HideFilterOrder: this.hideFilterOrder, // 隐藏过滤的订单
          ShowPreOrder: this.showPrepaidOrder, // 显示预付的订单
          // ShowAllOrder: this.showAllOrder, // 显示全部订单
          ShowSyncFailOrder: this.showFailOrder, // 显示同步失败订单
          HideDewuOrder: this.hideDuOrders, // 隐藏毒物订单
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getAgentOrderListPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < self.list.length; i++) {
                  self.checkboxModel.push(false);
                  // self.list[i].quantityOutOfStock = self.list[i].Quantity
                  for (let j = 0; j < self.list[i].AgentDetailList.length; j++) {
                    self.list[i].AgentDetailList[j].quantityOutOfStock = self.list[i].AgentDetailList[j].Quantity - self.list[i].AgentDetailList[j].SendQuantity;
                  }
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 跳转售后申请
      toAfterSalesApply(msg) {
        // let rightTabsContent = JSON.parse(sessionStorage.getItem('tabs'));
        this.$router.push({
          path: '/home/as_apply',
          query: {
            orderNum: msg.OrderId
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '售后申请';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '售后申请',
            name: '/home/as_apply',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '售后申请',
            name: '/home/as_apply',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/as_apply';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 跳转售后列表
      toAfterSalesList(msg) {
        this.$router.push({
          path: '/home/as_list',
          query: {
            orderNum: msg.OrderId
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '售后列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/as_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 查询复位——清空数据
      resetData() {
        this.getTime();
        this.orderNum = null;
        this.consignee = null;
        this.tel = null;
        this.courierNum = null;
        this.goodsNum = null;
        this.color = null;
        this.size = null;
        this.selectFlag = null;
        this.selectSource = null;
        this.selectLoseMoney = null;
        this.selectStore = [];
        this.selectOrderTime = 1;
        // this.startTime = null;
        // this.endTime = null;
        this.selectOrderStatus = [];
        this.selectChannelValue = [];
        this.selectCourierCompany = [];
        this.selectRegion = null;
        this.selectProvince = null;
        this.selectCity = null;
        this.selectArea = null;
        this.buyerID = null;
        this.selectIsSalesAfter = null;
        this.startNum = null;
        this.endNum = null;
        this.selectRemarkType = null;
        this.remarkTypeVal = null;
        this.selectOrderType = null;
        this.hideCancelOrder = false;
        this.hideSalesAfterOrder = false;
        this.hideReplacementOrder = false;
        this.hideFilterOrder = false;
        this.showPrepaidOrder = false;
        this.showAllOrder = false;
        this.showFailOrder = false;
        this.hideDuOrders = true;
      },

      // 显示高级搜索
      showAdvancedSearch() {
        this.advancedSearch = !this.advancedSearch;
        this.selectRegion = null;
        this.selectProvince = null;
        this.selectCity = null;
        this.selectArea = null;
        this.buyerID = null;
        this.selectIsSalesAfter = null;
        this.startNum = null;
        this.endNum = null;
        this.selectRemarkType = null;
        this.remarkTypeVal = null;
        this.selectOrderType = null;
        this.hideCancelOrder = false;
        this.hideSalesAfterOrder = false;
        this.hideReplacementOrder = false;
        this.hideFilterOrder = false;
        this.showPrepaidOrder = false;
        this.showAllOrder = false;
        this.showFailOrder = false;
        this.hideDuOrders = true;
      },

      // 订单操作按钮
      orderCtrlBtn(type) {
        this.isBatch = true;
        this.orderMsg = [];
        for (let i = 0; i < this.checkboxModel.length; i++) {
          if (this.checkboxModel[i]) {
            this.orderMsg.push(this.list[i].OrderId);
          }
        }
        switch (type) {
          case 'batchPayment': // 批量付款
            if (this.orderMsg.length) { // batchPayment allPayment
              this.orderMsg = [];
              for (let i = 0; i < this.checkboxModel.length; i++) {
                if (this.checkboxModel[i]) {
                  if (this.list[i].SysStatusName !== '待付款') {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '已选订单中存在非待付款状态订单数据，请重新选择';
                    return;
                  }
                  this.orderMsg.push(this.list[i].OrderId);
                }
              }
              this.isShow = true;
              this.dialogShowType = type;
              this.dialogTitle = '提示';
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择需要批量操作的订单';
            }
            break;
          case 'allPayment':
            this.isShow = true;
            this.dialogShowType = type;
            this.dialogTitle = '提示';
            break;
          case 'exportOrder':
            this.dialogTitle = '提示';
            this.title = '导出订单';
            break;
          case 'mergerOrder':
          case 'batchAudit':
          case 'activationOrder':
          case 'cancelOrder':
          case 'channelOrder':
          case 'addOrder':
          case 'sellerRemarks':
          case 'internalRemarks':
          case 'syncOnlineOrderSend':
          case 'batchPullBack':
            if (this.orderMsg.length) {
              this.orderMsg = [];
              for (let i = 0; i < this.checkboxModel.length; i++) {
                if (this.checkboxModel[i]) {
                  this.orderMsg.push(this.list[i].OrderId);
                }
              }
              this.isShow = true;
              this.dialogShowType = type;
              if (type === 'sellerRemarks') {
                this.dialogTitle = '批量编辑卖家备注';
              } else if (type === 'internalRemarks') {
                this.dialogTitle = '批量编辑内部备注';
              } else if (type === 'syncOnlineOrderSend') {
                this.dialogTitle = '同步发货信息';
              } else if (type === 'batchPullBack') {
                this.dialogTitle = '批量撤回';
              } else {
                this.dialogTitle = '提示';
              }
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择需要批量操作的订单';
            }
            break;
        }
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isBatch = false;
        switch (type) {
          case 'orderDetail':
            this.dialogTitle = '订单详情';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'changeWarehouse':
            if (msg.SysStatusName !== '待审') {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '非待审状态不能改仓';
              return;
            }
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            this.dialogTitle = '改仓';
            break;
          case 'copyOrder':
            if (msg.SysStatusName !== '待审') {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '非待审状态不复制';
              return;
            }
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            this.dialogTitle = '提示';
            break;
          case 'costPrice':
            this.dialogTitle = '成本价';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'batchAudit':
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            // this.orderMsg = [];
            // this.orderMsg.push(msg.OrderId);
            this.dialogTitle = '提示';
           /* if (msg.Storeroom.StoreroomName) {
              this.isShow = true;
              this.dialogShowType = type;
              this.orderMsg = msg;
              // this.orderMsg = [];
              // this.orderMsg.push(msg.OrderId);
              this.dialogTitle = '提示';
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '订单未分配渠道，不可进行审单操作';
            } */
            break;
          case 'remarks':
            this.dialogTitle = '编辑备注';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'cancelOrder':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'changeGoods':
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            this.dialogTitle = '改货';
            break;
          case 'splitOrder':
            this.dialogTitle = '拆单';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'channelOrder':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = [];
            this.orderMsg.push(msg.OrderId);
            break;
          case 'intelligentSplitOrder':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'activationOrder':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'pullBack':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'modifyReceivingInformation':
            this.dialogTitle = '编辑收货信息';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'outOfStockInformation':
            this.dialogTitle = '缺货信息';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'internalRemarks':
            this.dialogTitle = '编辑内部备注';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'sellerRemarks':
            this.dialogTitle = '编辑卖家备注';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'splitOrderDetail':
            if (msg.SplitJoinType === 2) {
              this.dialogTitle = '拆单详情';
            } else if (msg.SplitJoinType === 4) {
              this.dialogTitle = '合单详情';
            }
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'checkLog':
            this.dialogTitle = '日志';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'synchronizationFailureFlag':
            this.dialogTitle = '提示';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'modifyLogistic':
            this.dialogTitle = '修改物流';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'modifyLogisticPending': // 修改物流--待审
            this.dialogTitle = '修改物流';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break;
          case 'batchPayment': // 付款
            // this.orderCtrlBtn('batchPayment');
            this.orderMsg = [];
            this.orderMsg.push(msg.OrderId);
            this.isShow = true;
            this.dialogShowType = type;
            this.dialogTitle = '提示';
            break;
          case 'accountsExport': // 对账导出
            if (this.checkFormat()) {
              this.isShow = true;
              this.dialogShowType = type;
              this.dialogTitle = '提示';
              this.orderMsg = {
                OrderIdOrOutOrderId: this.orderNum, // 平台订单号/内部订单号
                ReceiveName: this.consignee, // 收货人
                Phone: this.tel, // 联系电话
                ExpressNum: this.courierNum, // 快递单号
                GoodsId: this.goodsNum, // 货号
                ColorName: this.color, // 颜色
                SizeName: this.size, // 尺码
                Flag: this.selectFlag, // 旗帜 灰0(不要此值) 红1 黄2 绿3 蓝4 紫5
                Source: this.selectSource, // 来源 1淘宝 2天猫 3京东 4拼多多 5唯品会 6零售下单
                LoseMoney: this.selectLoseMoney, // 是否亏本
                ShopList: this.selectStore, //  店铺
                QueryTimeType: this.selectOrderTime, // 查询时间类型 1下单时间 2付款时间 3发货时间 4交单时间
                QueryBeginTime: this.Global.timeFormatEight(this.startTime), // 查询开始时间
                QueryEndTime: this.Global.timeFormatEight(this.endTime), // 查询结束时间
                SysStatus: this.selectOrderStatus, // 状态 1待审、2待付款、3已付款、4待发货、5已发货、6部分发货、7整单缺货、8交易完成、9交易取消 ,
                StoreroomList: this.selectChannelValue, // 渠道
                LogisticList: this.selectCourierCompany, // 快递公司
                RegionId: this.selectRegion, // 地区
                ProvinceId: this.selectProvince, // 省份
                CityId: this.selectCity, // 城市
                AreaId: this.selectArea, // 区
                BuyerNick: this.buyerID, // 买家id
                ReStatus: this.selectIsSalesAfter, // 是否售后 1=无售后  2=有售后
                BeginQuantity: this.startNum, // 货品数量 起始
                EndQuantity: this.endNum, // 货品数量 结束
                RemarkType: this.selectRemarkType, // 备注类型 1 内部备注 2 系统备注 3 卖家备注 4 买家备注
                RemarkContent: this.remarkTypeVal, // 备注内容
                OrderType: this.selectOrderType, // 订单类型 1 普通订单 2 货到付款
                HideCancelOrder: this.hideCancelOrder, // 隐藏交易取消的订单
                HideReOrder: this.hideSalesAfterOrder, // 隐藏产生售后的订单
                HideExchangeOrder: this.hideReplacementOrder, // 隐藏置换的订单
                HideFilterOrder: this.hideFilterOrder, // 隐藏过滤的订单
                ShowPreOrder: this.showPrepaidOrder, // 显示预付的订单
                // ShowAllOrder: this.showAllOrder, // 显示全部订单
                ShowSyncFailOrder: this.showFailOrder, // 显示同步失败订单
                HideDewuOrder: this.hideDuOrders, // 隐藏毒物订单
                pageIndex: this.currentPage,
                pageSize: this.pageSize
              };
            }
            break;
          case 'detailExport': // 导出明细
            if (this.checkFormat()) {
              this.isShow = true;
              this.dialogShowType = type;
              this.dialogTitle = '提示';
              this.orderMsg = {
                OrderIdOrOutOrderId: this.orderNum, // 平台订单号/内部订单号
                ReceiveName: this.consignee, // 收货人
                Phone: this.tel, // 联系电话
                ExpressNum: this.courierNum, // 快递单号
                GoodsId: this.goodsNum, // 货号
                ColorName: this.color, // 颜色
                SizeName: this.size, // 尺码
                Flag: this.selectFlag, // 旗帜 灰0(不要此值) 红1 黄2 绿3 蓝4 紫5
                Source: this.selectSource, // 来源 1淘宝 2天猫 3京东 4拼多多 5唯品会 6零售下单
                LoseMoney: this.selectLoseMoney, // 是否亏本
                ShopList: this.selectStore, //  店铺
                QueryTimeType: this.selectOrderTime, // 查询时间类型 1下单时间 2付款时间 3发货时间 4交单时间
                QueryBeginTime: this.Global.timeFormatEight(this.startTime), // 查询开始时间
                QueryEndTime: this.Global.timeFormatEight(this.endTime), // 查询结束时间
                SysStatus: this.selectOrderStatus, // 状态 1待审、2待付款、3已付款、4待发货、5已发货、6部分发货、7整单缺货、8交易完成、9交易取消 ,
                StoreroomList: this.selectChannelValue, // 渠道
                LogisticList: this.selectCourierCompany, // 快递公司
                RegionId: this.selectRegion, // 地区
                ProvinceId: this.selectProvince, // 省份
                CityId: this.selectCity, // 城市
                AreaId: this.selectArea, // 区
                BuyerNick: this.buyerID, // 买家id
                ReStatus: this.selectIsSalesAfter, // 是否售后 1=无售后  2=有售后
                BeginQuantity: this.startNum, // 货品数量 起始
                EndQuantity: this.endNum, // 货品数量 结束
                RemarkType: this.selectRemarkType, // 备注类型 1 内部备注 2 系统备注 3 卖家备注 4 买家备注
                RemarkContent: this.remarkTypeVal, // 备注内容
                OrderType: this.selectOrderType, // 订单类型 1 普通订单 2 货到付款
                HideCancelOrder: this.hideCancelOrder, // 隐藏交易取消的订单
                HideReOrder: this.hideSalesAfterOrder, // 隐藏产生售后的订单
                HideExchangeOrder: this.hideReplacementOrder, // 隐藏置换的订单
                HideFilterOrder: this.hideFilterOrder, // 隐藏过滤的订单
                ShowPreOrder: this.showPrepaidOrder, // 显示预付的订单
                // ShowAllOrder: this.showAllOrder, // 显示全部订单
                ShowSyncFailOrder: this.showFailOrder, // 显示同步失败订单
                HideDewuOrder: this.hideDuOrders, // 隐藏毒物订单
                pageIndex: this.currentPage,
                pageSize: this.pageSize
              };
            }
            break;
          case 'aCheckList':
            this.dialogTitle = '一键审单';
            this.isShow = true;
            this.dialogShowType = type;
            break;
         /* case 'orderDetailInventory':
            this.dialogTitle = '订单明细库存信息';
            this.isShow = true;
            this.dialogShowType = type;
            this.orderMsg = msg;
            break; */
        }
      },

      // 获取订单一条详细的库存信息
      getOrderDetailInventory(type, orderId, goodDetail) {
        this.isBatch = false;
        this.dialogTitle = '订单明细库存信息';
        this.isShow = true;
        this.dialogShowType = type;
        // this.dialogShowType = 'orderDetailInventory';
        this.orderMsg = goodDetail;
        this.orderMsg.OrderId = orderId;
      },

      // 复制单个订单
      copyOrderSingle(orderMsg) {
        console.log(orderMsg);
        this.isLoading = true;
        this.$axios.post(this.Global.copyOrderSingle(orderMsg.OrderId), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (!res.data.errorMsg.length) {
              self.isMsg = true;
              self.isSuc = true;
              self.txtMsg = '复制成功';
            } else {
              self.isMsg = true;
              self.isSuc = false;
              self.txtMsg = res.data.errorMsg;
            }
          }, 500);
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.isMsg = true;
          this.isSuc = true;
          this.txtMsg = '操作成功';
          this.getAgentOrderListPageData();
          let time = 3;
          const self = this;
          const timer = setInterval(function () {
            time = --time;
            if (time < 1) {
              self.isMsg = false;
              clearInterval(timer);
            }
          }, 1000);
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        if (val < this.checkboxModel.length) {
          this.checkboxModel = this.checkboxModel.splice(0, val);
        }
        this.getAgentOrderListPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.checkboxModel = [];
        this.getAgentOrderListPageData();
      }
    },
    created() {
      this.getTime();
      if (this.$route.query['status']) {
        if (this.$route.query['status'] !== -1) {
          if (this.$route.query['status'] === 'showFailOrder') {
            this.selectOrderTime = 3;
            this.startTime = this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 * 2));
            this.endTime = this.Global.timeFormatEnd(new Date());
            this.advancedSearch = true;
            this.showFailOrder = true;
          } else {
            this.selectOrderStatus = [];
            this.selectOrderStatus.push(parseInt(this.$route.query['status']));
          }
        } else {
          this.selectChannelValue = [];
          this.selectChannelValue.push('enpty');
        }
      }
      this.getOrderSourceList();
      this.getAllPXShopList();
      this.getOrderSysStatusList();
      this.getOrderRemarkTypeList();
      this.getAllLogisticList();
      this.getAllRegionList();
      this.getAllProvinceList();
      this.getAllStoreroomsList();
      this.getAgentOrderListPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') {
        sessionStorage.setItem('isRefresh', 'false');
        this.isShow = false;
        this.resetData();
        this.getAgentOrderListPageData();
      } else {
        if (this.$route.query['status']) {
          this.resetData();
          if (this.$route.query['status'] !== -1) {
            this.selectOrderStatus = [];
            if (this.$route.query['status'] === 'showFailOrder') {
              this.selectOrderTime = 3;
              this.startTime = this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 * 2));
              this.endTime = this.Global.timeFormatEnd(new Date());
              this.advancedSearch = true;
              this.showFailOrder = true;
            } else {
              this.selectOrderStatus = [];
              this.selectOrderStatus.push(parseInt(this.$route.query['status']));
            }
            this.getAgentOrderListPageData();
          } else {
            this.selectChannelValue = [];
            this.selectChannelValue.push('enpty');
            this.getAgentOrderListPageData();
          }
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .order_list {
    padding: 5px;
    width: calc(100% - 10px);
    height: calc(100% - 10px);

    .order_list_top {
      .order_list_upper, .order_list_under {
        .first, .second, .third, .fourth {
          display: flex;
          margin-bottom: 5px;

          & > div {
            display: inline-block;
            margin-right: 3px;

            &:last-child {
              margin-right: 0;
            }
          }
        }

        .fourth {

          & > div {
            margin-right: 15px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }

    .order_btn {
      display: flex;
      margin-bottom: 10px;

      button {
        margin-right: 2px;
        padding: 7px 22px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .order_list_msg {
      padding: 0;
      font-size: 12px;

      &.hminus180 {
        height: calc(100% - 199px);
      }

      &.hminus120 {
        /*height: calc(100% - 123px);*/
        max-height: calc(100% - 119px);
      }

      &>table {
        td {
          min-width: 60px;

          &:first-child {
            min-width: 15px;
            width: 15px;
          }
        }
      }

      .table {
        tbody {
          /*border-bottom: 6px solid rgba(248, 248, 248, 1);*/
          &.bgc {
            background-color: #eeeeee;
          }

          &.bgy {
            background-color: #fff40175;
          }

          &:last-child {
            border-bottom: none;
          }

          tr {
            font-size: 12px;

            td.ctrl_btns {
              max-width: 75px;
              padding-left: 0;
              padding-right: 0;

              a {
                margin-right: 5px;
                white-space: nowrap;

                &:first-child {
                  /*margin-left: 5px;*/
                }

                &:last-child {
                  margin-right: 0;
                }
              }
            }

            &:nth-child(2), &:nth-child(3) {
              td {
                text-align: left;

                span {
                  font-weight: bold;
                }
              }
            }

            td {
              padding: 5px 0;

              &:first-child {
                padding: 4px 6px;
              }

              &:nth-child(2) {
                text-align: left;

                & > div {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }

              &.detail {
                p {
                  white-space: nowrap; /*不换行*/
                  text-align: left;
                  border-bottom: 1px solid #eee;

                  &:last-child {
                    border-bottom: none;
                  }
                }
              }

              &.ctrl_btn {

                div {
                  text-align: left;

                  a {
                    margin-right: 3px;
                    white-space: nowrap;
                  }
                }
              }
            }
          }

          .remark {
            p {
              /*min-width: 65px;*/
              max-width: 175px;
              height: 18px;
              padding-right: 15px;
            }

            span {
              display: inline-block;
              /*width: 66%;*/
              /*min-width: 31px;*/
              /*max-width: 80px;*/
              max-width: 163px;
              min-width: 80px;
              margin-right: 27px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            i.pa {
              right: 0;
              top: 26%;
            }
          }

          /*嵌在table里面的table*/
          .table {
            width: initial;
            border-top: none;
            border-left: none;
            border-right: none;

            td {
              min-width: initial;
              color: $calink;

              &.fcDel {
                color: #ff0000;
              }

              &:hover {
                cursor: pointer;
              }
            }

            tbody {
              &.bgc {
                background-color: #eeeeee;
              }

              &.bgy {
                background-color: #fff40175;
              }

              tr, th, td {
                text-align: left;
                border-top: none;
                border-left: none;
                border-right: none;
              }
              tr {
                td {
                  padding: 0;
                  text-align: left;
                  /*min-width: 60px;*/

                  &:first-child {
                    padding-right: 5px;
                    min-width: 5px;
                  }

                  &:last-child{
                    padding-left: 5px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/order-list.vue